// extracted by mini-css-extract-plugin
export default {"Navigation":"KExIPbibWRDSTRpk9XNA","NavigationWarning":"RuYl1iETm9sZ2wAvdIkh"};